import { render, staticRenderFns } from "./viewProduction.vue?vue&type=template&id=64681868&scoped=true&"
import script from "./viewProduction.vue?vue&type=script&lang=js&"
export * from "./viewProduction.vue?vue&type=script&lang=js&"
import style0 from "./viewProduction.vue?vue&type=style&index=0&id=64681868&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64681868",
  null
  
)

export default component.exports